import { useState, useLayoutEffect } from "react";
import { CouponTicket } from "@components/coupon-ticket";
import { api, ApiError } from "@utils/index";
import { SolidButton } from "@components/button";
import { SimpleModal } from "@components/simple-modal";
import { LoadingOverlay } from "@/apps/@components/loading-overlay";

/*
 * @name CouponWalletPage - 顯示優惠券頁面
 * 若要檢視無優惠券的畫面，請將 wallets 設為空陣列
 */

const CouponWalletPage = () => {
	// 定義 RWD 樣式
	const [containerClass, setContainerClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [emptyDescriptionClass, setEmptyDescriptionClass] = useState("");
	const [emptyImageClass, setEmptyImageClass] = useState("");
	const [ticketContainerClass, setTicketContainerClass] = useState("");
	const [buttonClass, setButtonClass] = useState("");
	const [button2Class, setButton2Class] = useState("");
	const [messageClass, setMessageClass] = useState("");
	// ---------------------------------------------------------------------------------

	const [isLoading, setIsLoading] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [redeemModal, setRedeemModal] = useState(false);
	const [wallets, setWallets] = useState(null);

	const getCouponWallet = async () => {
		setIsLoading(true);
		try {
			const res = await api.get("/coupon/list");
			const couponList = res.data.couponList;
			setWallets(couponList);
		} catch (err) {
			console.error(err);
			let msg = '無法送出表單';
			if (err.response.data?.code) {
				const errorCode = err.response.data.code;
				switch (errorCode) {
				case ApiError.COUPON_NOT_FOUND:
								msg = '查無資料';
					break;
				case ApiError.COUPON_INVALID:
								msg = '無效的優惠券';
					break;
				default:
					msg = '無法送出表單';
					break;
				}
			}
			alert(msg);
		} finally {
			setIsLoading(false);
		}
	};

	// 兌換優惠券
	const exchangeCouponHandler = async (couponId) => {
		try {
			const params = {
				coupon_id: couponId,
			};
			await api.post("/coupon/redeem", params);
			getCouponWallet();
			setRedeemModal(true);
		} catch (err) {
			console.error(err);
      let msg = '無法送出表單';
      if (err.response.data?.error?.code) {
        const errorCode = err.response.data.error.code;
        switch (errorCode) {
					case ApiError.COUPON_NOT_FOUND:
						msg = '此優惠無法兌換';
						break;
          case ApiError.INVALID_FORMAT:
            msg = '資料格式有誤';
            break;
          case ApiError.NOT_FOUND:
            msg = '查無資料';
            break;
          default:
            msg = '無法送出表單';
            break;
        }
      }
      setMessageModal(msg);
		}
	};

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		getCouponWallet();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setContainerClass("px-[59px] pb-[59px] flex flex-col items-center");
			setTitleClass("text-[23.5px] font-medium whitespace-nowrap");
			setEmptyDescriptionClass("text-[17px] font-normal whitespace-nowrap mt-8");
			setEmptyImageClass("h-auto w-[163px] mt-8");
			setTicketContainerClass("mt-7 w-full space-y-7");
			setButtonClass("px-14 py-1.5 text-[21px] mt-8 rounded-[10px]");
			setButton2Class("px-8 py-1.5 text-[21px] mt-8 rounded-[10px]");
			setMessageClass("w-[291px] h-auto pt-20 pb-16 text-[23.5px] font-medium");
		} else {
			setContainerClass("px-[6vw] pb-[6vw] flex flex-col items-center");
			setTitleClass("text-[4.53vw] font-medium whitespace-nowrap");
			setEmptyDescriptionClass("text-[3.28vw] font-normal whitespace-nowrap mt-[5vw]");
			setEmptyImageClass("h-auto w-[25vw] mt-[5vw]");
			setTicketContainerClass("mt-[4vw] w-full space-y-[4vw]");
			setMessageClass("w-[45vw] h-auto pt-[15vw] pb-[10vw] text-[4.53vw] font-medium");
			if (window.innerWidth > 460 && window.innerWidth <= 640) {
				setButtonClass("px-12 py-1.5 text-[21px] mt-6 rounded-[8px]");
				setButton2Class("px-4 py-1.5 text-[21px] mt-6 rounded-[8px]");
			} else if (window.innerWidth > 390 && window.innerWidth <= 460) {
				setButtonClass("px-10 py-2 text-[16px] mt-6 rounded-[6px]");
				setButton2Class("px-2 py-2 text-[16px] mt-6 rounded-[6px]");
			} else {
				setButtonClass("px-9 py-1.5 text-[15px] mt-4 rounded-[5px]");
				setButtonClass("px-9 py-1.5 text-[15px] mt-4 rounded-[4px]");
			}
		}
	};

	return (
		<div className={containerClass}>
			<LoadingOverlay visible={isLoading} />
			<label className={titleClass}>我的優惠</label>
			{wallets && wallets.length > 0 ?
				<div className={ticketContainerClass}>
					{wallets.map((coupon, index) => (
						<CouponTicket key={index} coupon={coupon} exchangeCouponHandler={exchangeCouponHandler} />
					))}
				</div>
			: wallets && wallets.length === 0 &&
				<div className={"flex flex-col items-center justify-center"}>
					<label className={emptyDescriptionClass}>目前沒有可用的優惠</label>
					<img
						alt={"empty"}
						className={emptyImageClass}
						src={window.assetUrl(
							"/images/liff/coupon-wallet-page/empty.png",
						)}
					/>
				</div>
			}
			<SimpleModal
				open={messageModal !== false}
				setOpen={setMessageModal}
				Content={
					<div className={"px-4 py-10 text-center"}>
						<div className={"flex flex-col items-center justify-center"}>
							<p className={messageClass}>{messageModal}</p>
						</div>
							<SolidButton
								onClick={()=>setMessageModal(false)}
								label={"確認"}
								buttonClass={button2Class + " w-full mt-[27%]"}
							/>
					</div>
				}
			/>
			<SimpleModal
				open={redeemModal}
				setOpen={setRedeemModal}
				Content={
					<div className={"px-4 py-10 text-center"}>
						<div className={"flex justify-center"}>
							<img
								alt={"message"}
								className={messageClass}
								src={window.assetUrl(
									"/images/liff/coupon-wallet-page/redeem-success-message.png",
								)}
							/>
						</div>
						<div className={"flex items-center gap-x-8"}>
							<SolidButton
								onClick={()=>setRedeemModal(false)}
								label={"確認"}
								buttonClass={buttonClass + " w-full"}
							/>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default CouponWalletPage;
